var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"active-class":"is-active","to":_vm.to,"exact":false}},[_c('span',{staticClass:"left"},[_vm._t("default")],2),_c('span',{staticClass:"right"})])}
var staticRenderFns = []

export { render, staticRenderFns }